module.exports = __webpack_public_path__ + "assets/8e011dc84edc1ab83c27a0a404f7b163.mp3";